module.exports = __webpack_public_path__ + "static/img/shaibao.46a8f92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/shaibao.jpg
// module id = 3SGe
// module chunks = 0